const Ed25519 = require('./crypto/ed25519');
const Secp256k1 = require('./crypto/secp256k1');

module.exports = {
    Ed25519,
    Secp256k1
};